import { UniversalCarType } from '../car-types/universal.car.type';
import { Wheel } from './wheel';

export class WheelCarPictureRequest {
    CarType: UniversalCarType;
    Wheel: Wheel;
}
